import * as Yup from 'yup';
import i18n from 'i18next';

export const initialValues = {
  recipentName: '',
  address: '',
  state: '',
  city: '',
  zipCode: '',
};

export const schema = Yup.object().shape({
  recipentName: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  address: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  city: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  zipCode: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
  state: Yup.string().required(i18n.t('common.fieldRequiredMessage')),
});
